import { useState } from 'react';
import FontSelection from './ui-components/fontSelection';
import ColourSelector from './ui-components/colourSelector';
import ShadowSelector from './ui-components/shadowSelector';
import ImageToData from './ui-components/imageToData';
import ShowHide from './ui-components/showHide';

function UserInterface(props) {
    const styleDefault = {
        tabA: { color: "black" },
        tabB: { color: "black" },
        tabC: { color: "black" },
        contentA: { display: "none" },
        contentB: { display: "none" },
        contentC: { display: "none" },
    };

    const [uiStyle, setUiStyle] = useState({ ...styleDefault, ...{ tabA: { background: "whitesmoke", color: "black" }, contentA: { display: "block" } } });

    function handleTab(content) {
        if (content === 1) {
            setUiStyle({ ...styleDefault, ...{ tabA: { background: "whitesmoke", color: "black" }, contentA: { display: "block" } } })
        }
        if (content === 2) {
            setUiStyle({ ...styleDefault, ...{ tabB: { background: "whitesmoke", color: "black" }, contentB: { display: "block" } } })
        }
        if (content === 3) {
            setUiStyle({ ...styleDefault, ...{ tabC: { background: "whitesmoke", color: "black" }, contentC: { display: "block" } } })
        }
    }

    return (
        <div className="ui">
            <div className="uiTabs">
                <h3 style={uiStyle.tabA} onClick={() => handleTab(1)}>Font Options</h3>
                <h3 style={uiStyle.tabB} onClick={() => handleTab(2)}>Color Options</h3>
                <h3 style={uiStyle.tabC} onClick={() => handleTab(3)}>Extra Styling</h3>
            </div>
            {/* <h2>Font Options</h2> */}
            <div className="uiContent" style={uiStyle.contentA}>
                <FontSelection setFontChoice={props.setFontChoice} setFontName={props.setFontName} />
                <div className="uiElement">
                    <h3>Font Weight</h3>
                    <input type="number" min="300" max="900" step="100" defaultValue="800" onChange={e => props.setFontExtras({ ...props.fontExtras, weight: e.target.value })} />
                </div>
                <div className="uiElement">
                    <h3>Letter Spacing</h3>
                    <input type="number" min="-3" max="3" step="0.2" defaultValue="0" onChange={e => props.setFontExtras({ ...props.fontExtras, space: e.target.value })} />
                </div>
            </div>
            {/* <h2>Colour Options</h2> */}
            <div className="uiContent" style={uiStyle.contentB}>
                <ColourSelector setColour={props.setBackgroundFill} colour={props.backgroundFill} title="Background Color" />
                <ColourSelector setColour={props.setParamFill} colour={props.paramFill} title="Parameter Background Color" />
                <ColourSelector setColour={props.setFontColour} colour={props.fontColour} title="Font Color" />
                <ColourSelector setColour={props.setHighlightColour} colour={props.highlightColour} title="Highlight Color" />
                <ColourSelector setColour={props.setDarkFill} colour={props.darkFill} title="Dark Color" />
                <ColourSelector setColour={props.setKnobColour} colour={props.knobColour} title="Knob Color" />
                <ColourSelector setColour={props.setEnvFill} colour={props.envFill} title="Env. LFO Velo. Color" />
                <ColourSelector setColour={props.setWaveBG} colour={props.waveBG} title="Waveshape Color" />
                <ColourSelector setColour={props.setEnvBG} colour={props.envBG} title="Env. LFO Velo. Background Color" />
                <ColourSelector setColour={props.setOutlineColour} colour={props.outlineColour} title="Outline Color" />
                <ColourSelector setColour={props.setKeysColourA} colour={props.keysColourA} title="Keys Color" />
                <ColourSelector setColour={props.setKeysColourB} colour={props.keysColourB} title="Sharp Keys Color" />
                {/* <ColourSelector setColour={props.setModOutsideColour} colour={props.modOutsideColour} title="Mod / Pitch Outside" />
                <ColourSelector setColour={props.setModInsideColour} colour={props.modInsideColour} title="Mod / Pitch Inside" /> */}

                {/* <ColourSelector setColour={setBackgroundFillB} title="Background Colour B" /> */}
                {/* <ColourSelector setColour={setHeadingBG} title="Heading Background Colour" /> */}
            </div>
            {/* <h2>Additional Styling</h2> */}
            <div className="uiContent" style={uiStyle.contentC}>
                <div className="uiElement">
                    <ShadowSelector setStyle={props.setStyledText} colour={"#000000"} title="Text Shadow" />
                </div>
                <div className="uiElement">
                    <ShadowSelector setStyle={props.setBoxStyle} colour={"#000000"} title="Parameter Box Shadow" />
                </div>
                <div className="uiElement">
                    <ShowHide setLogoHide={props.setLogoHide} logoHide={props.logoHide} title={"Logo"}/>
                </div>
                <div className="uiElement">
                    <ImageToData setImage1={props.setImage1} />
                </div>
            </div>
        </div>
    )
}

export default UserInterface;